// extracted by mini-css-extract-plugin
export var orderSummary = "_nq-0";
export var showMoreLessButton = "_nq-1";